var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase } from "../reactquestion_element";
import { ReactElementFactory } from "../element-factory";
import { TitleElement } from "./title/title-element";
var HeaderMobile = /** @class */ (function (_super) {
    __extends(HeaderMobile, _super);
    function HeaderMobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HeaderMobile.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    HeaderMobile.prototype.renderLogoImage = function () {
        var componentName = this.model.survey.getElementWrapperComponentName(this.model.survey, "logo-image");
        var componentData = this.model.survey.getElementWrapperComponentData(this.model.survey, "logo-image");
        return ReactElementFactory.Instance.createElement(componentName, {
            data: componentData,
        });
    };
    HeaderMobile.prototype.render = function () {
        return (React.createElement("div", { className: "sv-header--mobile" },
            this.model.survey.hasLogo ? (React.createElement("div", { className: "sv-header__logo" }, this.renderLogoImage())) : null,
            this.model.survey.hasTitle ? (React.createElement("div", { className: "sv-header__title", style: { maxWidth: this.model.renderedTextAreaWidth } },
                React.createElement(TitleElement, { element: this.model.survey }))) : null,
            this.model.survey.renderedHasDescription ? (React.createElement("div", { className: "sv-header__description", style: { maxWidth: this.model.renderedTextAreaWidth } },
                React.createElement("div", { className: this.model.survey.css.description }, SurveyElementBase.renderLocString(this.model.survey.locDescription)))) : null));
    };
    return HeaderMobile;
}(React.Component));
export { HeaderMobile };
var HeaderCell = /** @class */ (function (_super) {
    __extends(HeaderCell, _super);
    function HeaderCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HeaderCell.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    HeaderCell.prototype.renderLogoImage = function () {
        var componentName = this.model.survey.getElementWrapperComponentName(this.model.survey, "logo-image");
        var componentData = this.model.survey.getElementWrapperComponentData(this.model.survey, "logo-image");
        return ReactElementFactory.Instance.createElement(componentName, {
            data: componentData,
        });
    };
    HeaderCell.prototype.render = function () {
        return (React.createElement("div", { className: this.model.css, style: this.model.style },
            React.createElement("div", { className: "sv-header__cell-content", style: this.model.contentStyle },
                this.model.showLogo ? (React.createElement("div", { className: "sv-header__logo" }, this.renderLogoImage())) : null,
                this.model.showTitle ? (React.createElement("div", { className: "sv-header__title", style: { maxWidth: this.model.textAreaWidth } },
                    React.createElement(TitleElement, { element: this.model.survey }))) : null,
                this.model.showDescription ? (React.createElement("div", { className: "sv-header__description", style: { maxWidth: this.model.textAreaWidth } },
                    React.createElement("div", { className: this.model.survey.css.description }, SurveyElementBase.renderLocString(this.model.survey.locDescription)))) : null)));
    };
    return HeaderCell;
}(React.Component));
export { HeaderCell };
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Header.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Header.prototype.getStateElement = function () {
        return this.model;
    };
    Header.prototype.renderElement = function () {
        this.model.survey = this.props.survey;
        if (!(this.props.survey.headerView === "advanced") || this.model.isEmpty) {
            return null;
        }
        var headerContent = null;
        if (this.props.survey.isMobile) {
            headerContent = React.createElement(HeaderMobile, { model: this.model });
        }
        else {
            headerContent = (React.createElement("div", { className: this.model.contentClasses, style: { maxWidth: this.model.maxWidth } }, this.model.cells.map(function (cell, index) { return React.createElement(HeaderCell, { key: index, model: cell }); })));
        }
        return (React.createElement("div", { className: this.model.headerClasses, style: { height: this.model.renderedHeight } },
            this.model.backgroundImage ? React.createElement("div", { style: this.model.backgroundImageStyle, className: this.model.backgroundImageClasses }) : null,
            headerContent));
    };
    Header.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.processResponsiveness();
    };
    Header.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.model.processResponsiveness();
    };
    return Header;
}(SurveyElementBase));
export { Header };
ReactElementFactory.Instance.registerElement("sv-header", function (props) {
    return React.createElement(Header, props);
});
